import {ClientInfo} from '../../classes/client/client-info';

export abstract class ClientUtils {

  static getClientInfo(): ClientInfo {
    try {
      const userAgent = navigator.userAgent;
      const { name, version } = this.parseBrowserInfo(userAgent);

      return {
        screenSize: screen.width + "x" + screen.height,
        screenAvailableSize: screen.availWidth + "x" + screen.availHeight,
        browserName: name,
        browserVersion: version,
        browserUserAgent: userAgent,
        browserPlatform: navigator.platform || 'unknown'
      };
    } catch (e) {
      return {
        screenSize: 'unknown',
        screenAvailableSize: 'unknown',
        browserName: 'unknown',
        browserVersion: 'unknown',
        browserUserAgent: 'unknown',
        browserPlatform: 'unknown'
      };
    }
  } 
  
  private static parseBrowserInfo(userAgent: string): { name: string; version: string } {
    if (userAgent.indexOf('Firefox') > -1) {
      return {
        name: 'Firefox',
        version: userAgent.match(/Firefox\/([0-9.]+)/)?.[1] || 'Unknown'
      };
    } else if (userAgent.indexOf('Edg') > -1) {
      return {
        name: 'Edge',
        version: userAgent.match(/Edg\/([0-9.]+)/)?.[1] || 'Unknown'
      };
    } else if (userAgent.indexOf('Chrome') > -1) {
      return {
        name: 'Chrome',
        version: userAgent.match(/Chrome\/([0-9.]+)/)?.[1] || 'Unknown'
      };
    } else if (userAgent.indexOf('Safari') > -1) {
      return {
        name: 'Safari',
        version: userAgent.match(/Version\/([0-9.]+)/)?.[1] || 'Unknown'
      };
    }
    return { name: 'Unknown', version: 'Unknown' };
  }
}
